import { TextField } from '@mui/material';
import { useState } from 'react';

import { suspendLicence } from '../../api/admin/endpoints';
import { useAppMutation } from '../../api/useAppMutation';
import { FormDialog } from '../../components/FormDialog';
import { useT } from '../../i18n/LanguageContext';

/** Suspending makes the business read-only at once (BR-04); the reason goes to the audit log. */
export const SuspendLicenceDialog = ({ tenantId, onClose }: { tenantId: string; onClose: () => void }) => {
  const t = useT();
  const [reason, setReason] = useState('');
  const mutation = useAppMutation(
    () => suspendLicence(tenantId, reason.trim()),
    ['tenant', 'tenants', 'audit'],
    onClose,
  );

  return (
    <FormDialog
      title={t('licence.suspend')}
      onClose={onClose}
      onSubmit={() => mutation.mutate(undefined)}
      submitLabel={t('licence.suspend')}
      isBusy={mutation.isPending}
      error={mutation.error}
    >
      <TextField
        required
        multiline
        minRows={2}
        label={t('licence.suspendReason')}
        helperText={t('licence.suspendHint')}
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />
    </FormDialog>
  );
};
